import { Router, ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Component({
    templateUrl: './login.component.html',
    standalone: false
})
export class LoginComponent implements OnInit {
    //private redirectUrl: string = '';
    //private redirectParams: string[] = [];

    constructor(private router: Router, private route: ActivatedRoute, public authService: AuthService) {
        //var ok = router;
        //var test = route;
    }

    ngOnInit() {
        this.authService.initAuth();
        //if (this.authService.authenticated) {
        //    //if (this.router.url.toLowerCase().includes('login')) this.router.navigate(['/home']);
        //    this.router.navigate(['/home']);
        //}
        //else {
        //}
    }

    async login(): Promise<void> {
        //this.authService.signIn();
        this.router.navigate(['/home']);
        //this.authService.loginPopup();
    }

    logout() {
        //this.authService.signOut();
        this.authService.logout();
    }
}